module.exports = __webpack_public_path__ + "img/double_mstsation_product.c61c2a7c.png";